import React, { useEffect, useState } from "react";

export default function SidebarCategories({ selectedLocations, setSelectedLocations }) {
  const [categories, setCategories] = useState([]);
  const [openCategory, setOpenCategory] = useState(null);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/destinationwithcountingactivity")
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setCategories(data.data);
        }
      })
      .catch((err) => {
        console.log("API Error:", err);
      });
  }, []);

  const toggleCategory = (cat) => {
    setOpenCategory(openCategory === cat ? null : cat);
  };

  // Use ID instead of name
  const handleLocationChange = (id) => {
    setSelectedLocations((prev) => {
      if (prev.includes(id)) {
        return prev.filter((loc) => loc !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  return (
    <div>
      <ul className="sidebar-list">
        {categories.map((cat, index) => (
          <li key={index} className="sidebar-category-dropdown">
            <label className="containerss">
              <input type="checkbox" />
              <span className="checkmark" />
              <strong>{cat.category.toUpperCase()}</strong>
            </label>

            <i
              className={`bi bi-caret-right-fill sidebar-category-icon ${
                openCategory === cat.category ? "active" : ""
              }`}
              onClick={() => toggleCategory(cat.category)}
            />

            {openCategory === cat.category && (
              <ul className="subcategory-list">
                {cat.locations.map((loc) => (
                  <li key={loc.id} className="subcategory-item">
                    <label className="containerss">
                      <input
                        type="checkbox"
                        checked={selectedLocations.includes(loc.id)} // CHECK BY ID
                        onChange={() => handleLocationChange(loc.id)} // PASS ID
                      />
                      <span className="checkmark"></span>
                      {loc.name} ({loc.activity_count})
                    </label>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
